import { dialogues } from '../../content/dialogues';
import type { EventBus } from '../../game/events/EventBus';
import type { ConditionEvaluator } from '../rules/ConditionEvaluator';
import type { GameStateStore } from '../state/GameStateStore';
import type { DialogueChoice, DialogueDefinition, DialogueNode } from '../types';

export class DialogueService {
  constructor(
    private readonly store: GameStateStore,
    private readonly evaluator: ConditionEvaluator,
    private readonly events: EventBus,
  ) {}

  start(dialogueId: string): void {
    const dialogue = dialogues[dialogueId];
    if (!dialogue) throw new Error(`Ukendt dialog: ${dialogueId}`);
    const node = this.#node(dialogue, dialogue.startNodeId);
    this.events.emit('dialogue:start', { dialogue, node });
  }

  availableChoices(node: DialogueNode): DialogueChoice[] {
    return (node.choices ?? []).filter((choice) =>
      this.evaluator.evaluateAll(choice.conditions, this.store.snapshot),
    );
  }

  next(
    dialogue: DialogueDefinition,
    node: DialogueNode,
    choice?: DialogueChoice,
  ): DialogueNode | null {
    const nextId = choice?.nextNodeId ?? node.nextNodeId;
    return nextId ? this.#node(dialogue, nextId) : null;
  }

  #node(dialogue: DialogueDefinition, nodeId: string): DialogueNode {
    const node = dialogue.nodes.find((entry) => entry.id === nodeId);
    if (!node) throw new Error(`Dialogen ${dialogue.id} mangler node ${nodeId}.`);
    return node;
  }
}
